import React from 'react';
import PropTypes from 'prop-types';
import CoreDivider from '../../Divider';
const Divider = props => React.createElement(CoreDivider, Object.assign({}, props));
Divider.propTypes = {
    /** Applies a data-hook HTML attribute that can be used in the tests. */
    dataHook: PropTypes.string,
};
Divider.displayName = 'Card.Divider';
export default Divider;
//# sourceMappingURL=index.js.map